<template>
  <van-popup :value="productsVisible" @click-overlay="hideProducts" :lock-scroll="false" :close-on-click-overlay="false" position="bottom" class="products-popup">
    <div class="scroll-container">
      <van-tabs v-model="activeIndex" animated>
        <van-tab>
          <div class="products-popup-wrapper scroll-height">
            <div @click="goToDetail(item)" v-for="(item, index) in list" :key="index" class="product">
              <div class="product-inner">
                <div class="product-cover">
                  <img :src="item.imageListGoods | filterPicture" />
                  <span class="product-cover-tag">{{ item.sort }}</span>
                </div>
                <div class="product-info">
                  <div class="product-info-header">
                    <p class="product-info-name two-line">
                      <span class="product-info-tag">{{ item | filterType }}</span>
                      <span style="font-weight: 700">{{ item.boldName }}</span>
                      <span>{{ item.name }}</span>
                    </p>
                    <p class="product-info-area one-line">{{ item.description }}</p>
                    <p class="product-info-deadline">有效期至 {{ item.expireTime | filterExpireTime }}</p>
                  </div>
                  <div class="product-info-footer">
                    <div class="product-info-footer-left">
                      <span v-if="['LUCKYBAG', 'VOUCHER'].indexOf(item.type) !== -1" class="product-info-price">¥{{ item.price | filterPrice }}</span>
                    </div>
                    <!-- <img v-if="item.whetherBuy" :src="'/dg3/static/assets/product-' + (['LUCKYBAG', 'VOUCHER'].indexOf(item.type) !== -1 ? 'paid' : 'received') + '.png'" class="product-received-tag" />
                    <van-button v-else type="primary" size="small" :disabled="!item.onsale">{{ item.onsale ? '马上抢' : '未开售' }}</van-button> -->

                    <img v-if="item.whetherBuy" :src="'/dg3/static/assets/product-' + (['LUCKYBAG', 'VOUCHER'].indexOf(item.type) !== -1 ? 'paid' : 'received') + '.png'" class="product-received-tag" />
                    <van-button v-else-if="item.type === 'VOUCHER'" type="primary" size="small">马上抢</van-button>
                    <van-button v-else type="primary" size="small" disabled>已结束</van-button>
                  </div>
                </div>
              </div> 
            </div>
          </div>
        </van-tab>
        <van-tab>
          <div class="detail-wrapper scroll-height">
            <div class="detail-cover">
              <img :src="detail.imageDetailGoods | filterPicture" />
              <span class="detail-cover-tag">{{ detail.sort }}</span>
            </div>
            <div class="detail-info">
              <p class="detail-info-name">
                <span class="detail-info-tag">{{ detail | filterType }}</span>
                <span style="font-weight: 700">{{ detail.boldName }}</span>
                <span>{{ detail.name }}</span>
              </p>
              <p v-if="['LUCKYBAG', 'VOUCHER'].indexOf(detail.type) !== -1" class="detail-info-price">¥{{ detail.price | filterPrice }}</p>
            </div>
            <div class="detail-desc">
              <div class="detail-title">
                <span class="detail-title-text">商品详情</span>
              </div>
              <p :class="{ 'two-line': !detailMore }" class="detail-desc-text" v-html="detail.detail"></p>
              <a @click="detailMore = !detailMore" class="detail-desc-more">{{ detailMore ? '收起' : '展开' }}</a>
            </div>
            <div v-if="detail.type !== 'VISITGIFT' && !detail.whetherBuy" class="detail-form">
              <div class="detail-title">
                <span class="detail-title-text">商品激活</span>
              </div>
              <p class="detail-form-subtitle">请准确填写并校对以下消息，方便工作人员联系你~</p>
              <div class="detail-form-field">
                <van-field v-model="form.name" class="detail-form-field-inner" placeholder="请输入姓名" />
              </div>
              <div class="detail-form-field">
                <van-field v-model="form.phone" type="number" class="detail-form-field-inner" placeholder="请输入手机" />
                <van-button v-if="showFormCode" @click="sendCode" :disabled="countdown > 0" class="detail-form-field-btn" type="info">{{ countdown === 0 ? '获取验证码' : '发送中（' + countdown + 'S）' }}</van-button>
              </div>
              <div v-if="showFormCode" class="detail-form-field">
                <van-field v-model="form.phoneCode" type="number" class="detail-form-field-inner" placeholder="请输入验证码" />
              </div>
              <div v-if="detail.type !== 'VIP'" class="detail-form-field">
                <van-field v-model="form.idCard" class="detail-form-field-inner" placeholder="请输入身份证后四位" />
              </div>
            </div>
            <div v-if="!detail.onsale" class="detail-operation">
              <van-button class="detail-operation-btn" type="primary" disabled>暂未开售</van-button>
            </div>
            <div v-else-if="detail.whetherBuy" class="detail-operation">
              <van-button class="detail-operation-btn" type="primary" disabled>已购买</van-button>
            </div>
            <div v-else-if="!detail.whetherBuy" class="detail-operation">
              <van-button @click="backList" class="detail-operation-btn" type="info" plain>我再想想</van-button>
              <van-button @click="createOrder" class="detail-operation-btn" type="primary">马上抢</van-button>
            </div>
          </div>
        </van-tab>
      </van-tabs>

      <div class="safe-area" />
      <img v-if="activeIndex === 1" @click="backList" class="back-list" src="/dg3/static/assets/back-list.png" />
    </div>
  </van-popup>
</template>

<script>
import { mapState } from 'vuex'
import WechatSdk from 'weixin-js-sdk'

export default {
  data () {
    return {
      activeIndex: 0,
      detailMore: false,
      detail: {},
      countdown: 0,
      timer: null,

      form: {
        name: '',
        phone: '',
        phoneCode: '',
        idCard: '',
      },

      showFormCode: false
    }
  },

  computed: {
    ...mapState({
      roomId: (state) => state.room.id,
      list: (state) => state.products.list,
      onsale: (state) => state.products.onsale,
      productsVisible: (state) => state.products.visible,
    })
  },

  watch: {
    activeIndex () {
      this.form.phoneCode = ''
      this.scrollToTop()
    }
  },

  filters: {
    filterType (row) {
      if (row.id === '1329616751821848578' || row.id === '1329616751821848591') return 'VIP 看房'

      const map = {
        VIP: 'VIP 看商铺',
        VISITGIFT: '到访礼',
        LUCKYBAG: '福袋',
        VOUCHER: '购房券',
      }

      return map[row.type] || row.type
    },

    filterExpireTime (time) {
      return time.slice(0, 10).replace(/-/g, '.')
    }
  },

  methods: {
    initForm (userInfo) {
      if (userInfo) {
        this.form.name = userInfo.memberName
        this.form.phone = userInfo.memberMobile
        this.form.idCard = userInfo.memberIdcard
      }
      
      console.log(userInfo)
    },

    hideProducts () {
      this.$store.commit('hideProducts')
    },

    goToDetail (row) {
      if (row.type !== 'VOUCHER') return this.toast('直播已结束，已不能领取（or抢购）哦~')

      this.detail = row
      this.activeIndex = 1

      this.showFormCode = !this.form.phone
    },

    goToOnsaleProduct () {
      const row = this.list.find(item => item.id === this.onsale.id)

      if (row) {
        this.toast.loading({ duration: 500 })
        this.goToDetail(row)
        
        setTimeout(() => {
          this.$store.commit('showProducts')
          this.$nextTick(() => this.scrollToTop())
        }, 500)
      }
    },

    createOrder () {
      ['LUCKYBAG', 'VOUCHER'].indexOf(this.detail.type) !== -1 ? this.goToBuy() : this.goToReceive()
    },

    goToReceive () {
      let form = { goodsId: this.detail.id }
      
      if (this.detail.type === 'VIP') {
        if (!this.form.name) return this.toast('姓名不能为空')
        if (!this.form.phone) return this.toast('手机号不能为空')
        
        form.memberName = this.form.name
        form.memberMobile = this.form.phone

        if (this.showFormCode) {
          if (!this.form.phoneCode) return this.toast('验证码不能为空')
          form.smsCode = this.form.phoneCode
        }
      }

      this.toast.loading({ duration: 0, mask: true })

      this.request({ url: '/liveGoodsOrder/createOrder', data: form }).then(res => {
        this.handleSuccess('领取成功，请在个人中心查看详情~')
      }).catch(err => {
        if (err.data.code === 101) {
          this.showFormCode = true
          this.toast.fail('检测到新手机号，请输入验证码')
        } else {
          this.toast.fail(err.data.message)
        }
      })
    },

    goToBuy () {
      if (!this.form.name) return this.toast('姓名不能为空')
      if (!this.form.phone) return this.toast('手机号不能为空')
      if (!this.form.idCard) return this.toast('身份证不能为空')

      let form = {
        goodsId: this.detail.id,
        memberName: this.form.name,
        memberIdcard: this.form.idCard,
        memberMobile: this.form.phone,
      }

      if (this.showFormCode) {
        if (!this.form.phoneCode) return this.toast('验证码不能为空')
        form.smsCode = this.form.phoneCode
      }

      this.toast.loading({ duration: 0, mask: true })

      this.request({ url: '/liveGoodsOrder/createOrder', data: form }).then(payRes => {
        WechatSdk.chooseWXPay({
          timestamp: payRes.result.timeStamp,
          nonceStr: payRes.result.nonceStr,
          package: payRes.result.packageValue,
          signType: payRes.result.signType,
          paySign: payRes.result.paySign,
          success: (res) =>  this.handleSuccess('购买成功，请在个人中心查看详情~'),
          fail: (error) => setTimeout(() => this.toast('未知错误，请联系管理员'), 500),
          complete: () => this.toast.clear()
        })
      }).catch(err => {
        if (err.data.code === 101) {
          this.showFormCode = true
          this.toast.fail('检测到新手机号，请输入验证码')
        } else {
          this.toast.fail(err.data.message)
        }
      })
    },

    handleSuccess (message) {
      this.hideProducts()
      this.$store.commit('setProductPaid', this.detail.id)

      setTimeout(() => {
        this.toast(message)
        this.backList()
      }, 500)
    },

    backList () {
      this.activeIndex = 0
      this.detailMore = false
    },

    sendCode () {
      if (this.countdown > 0) return

      if (!this.form.phone) return this.toast.fail('请先填写手机号')

      this.toast.loading({ duration: 0 })
      this.request({ url: '/util/code/getSmsCodeByAliyun', data: { mobile: this.form.phone, restful: false }}).then(res => {
        this.setCountdown()
        this.toast.success('验证码已发送到您的手机号')
      })
    },

    setCountdown () {
      this.countdown = 60

      this.timer = setInterval(() => {
        if (this.countdown > 0) --this.countdown
        else clearInterval(this.timer)
      }, 1000)
    },
    
    scrollToTop () {
      let container = document.getElementsByClassName('scroll-container')[0]

      if (container) container.scrollTop = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.products-popup {
  border-radius: .2rem .2rem 0 0;
  .scroll-container {
    height: calc(100vh - 3.65rem - (30vw * .5625));
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    .scroll-height {
      min-height: calc(100vh - 3.65rem - (50vw * .5625));
      overflow: hidden;
    }
  }
  .products-popup-wrapper {
    padding: .1rem 0;
    .product {
      padding: .24rem;
      border-bottom: 1px solid #EAEAEA;
      .product-inner {
        position: relative;
        display: flex;
        height: 2rem;
        .product-cover {
          position: relative;
          flex-shrink: 0;
          margin-right: .24rem;
          width: 2rem;
          height: 100%;
          border-radius: .1rem;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .product-cover-tag {
            position: absolute;
            top: 0;
            left: 0;
            padding: 0 .12rem;
            min-width: .5rem;
            line-height: .32rem;
            font-size: .24rem;
            color: #FFF;
            text-align: center;
            background: linear-gradient(90deg, #FDA037, #FF7B16);
            border-bottom-right-radius: .12rem;
          }
        }
        .product-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
          .product-info-header {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            .product-info-name {
              margin-right: .1rem;
              color: #282828;
              span {
                line-height: .4rem;
                font-size: .28rem;
                vertical-align: middle;
              }
              .product-info-tag {
                display: inline-block;
                padding: 0 .06rem;
                line-height: .32rem;
                color: #FFF;
                background-color: #FF0807;
                border-radius: .04rem;
                font-size: .24rem;
              }
            }
            .product-info-area {
              margin-top: .15rem;
            }
            .product-info-area, .product-info-deadline {
              color: #F51614;
              font-size: .24rem;
            }
          }
          .product-info-footer {
            display: flex;
            align-items: center;
            .product-info-footer-left {
              flex: 1;
              display: flex;
              align-items: center;
              .product-info-price {
                margin-right: .16rem;
                line-height: .5rem;
                font-size: .32rem;
                font-weight: 700;
                color: #F51614;
              }
            }
            .product-received-tag {
              position: absolute;
              right: 0;
              bottom: 0;
              width: 1rem;
              height: 1rem;
            }
          }
        }

      }
      &:last-child {
        border-bottom: 0;
      }
    }
  }
  .detail-wrapper {
    position: relative;
    .detail-cover {
      position: relative;
      margin: .32rem .24rem 0;
      border-radius: .12rem;
      overflow: hidden;
      img {
        display: block;
        width: 100%;
      }
      .detail-cover-tag {
        position: absolute;
        top: 0;
        left: 0;
        padding: 0 .12rem;
        min-width: .8rem;
        line-height: .4rem;
        font-size: .24rem;
        text-align: center;
        color: #FFF;
        background: linear-gradient(90deg, #FDA037, #FF7B16);
        border-bottom-right-radius: .12rem;
      }
    }
    .detail-info {
      display: flex;
      align-items: center;
      margin: .24rem .24rem 0;
      padding-bottom: .24rem;
     .detail-info-name {
        color:#282828;
        span {
          font-size: .28rem;
          line-height: .45rem;
          vertical-align: middle;
        }
        .detail-info-tag {
          display: inline-block;
          padding: 0 .06rem;
          line-height: .4rem;
          color: #FFF;
          background-color: #FF0807;
          border-radius: .04rem;
          font-size: .24rem;
        }
      }
      .detail-info-price {
        margin-left: .3rem;
        color: #F51614;
        font-size: .36rem;
        line-height: .5rem;
        font-weight: 700;
      }
    }
    .detail-desc {
      margin: 0 .24rem;
      padding: .24rem 0;
      border-top: 1px solid #EAEAEA;
      .detail-desc-text {
        margin-top: .24rem;
        line-height: .4rem;
        font-size: .28rem;
        color:#282828;
      }
      .detail-desc-more {
        margin-top: .1rem;
        line-height: .4rem;
        font-size: .28rem;
        color: #1989fa;
      }
    }
    .detail-form {
      margin: 0 .24rem;
      padding-top: .24rem;
      border-top: 1px solid #EAEAEA;
      .detail-form-subtitle {
        margin-top: .24rem;
        line-height: .34rem;
        font-size: .24rem;
        color: #666;
      }
      .detail-form-field {
        display: flex;
        align-items: center;
        margin: .24rem .3rem 0;
        height: .76rem;
        .detail-form-field-inner {
          flex: 1;
          display: flex;
          align-items: center;
          padding: 0 .32rem;
          height: .76rem;
          background-color: #F5F5F5;
          border-radius: .12rem;
        }
        .detail-form-field-btn {
          margin-left: .12rem;
          height: 100%;
        }
      }
    }
    .detail-operation {
      display: flex;
      margin: .4rem .24rem .7rem;
      .detail-operation-btn {
        flex: 1;
        height: .88rem;
        border-radius: .2rem;
        &:first-child {
          margin-right: .12rem;
        }
        &:last-child {
          margin-left: .12rem;
        }
      }
    }
    .detail-title {
      position: relative;
      height: .4rem;
      .detail-title-text {
        line-height: .4rem;
        color: #F51614;
        font-weight: 700;
      }
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -.24rem;
        height: .4rem;
        width: .08rem;
        background-color: #F51614;
      }
    }
  }
  .back-list {
    position: fixed;
    right: .24rem;
    bottom: 1rem;
    width: .86rem;
    height: .86rem;
  }
}
</style>

<style lang="scss">
.products-popup {
  .van-tabs__wrap {
    display: none;
  }
  .van-button--small {
    padding: 0 .32rem;
    height: .54rem;
    border-radius: .32rem;
  }
  .van-button--primary {
    background: linear-gradient(90deg, #FFAE07 0%, #FF0307 100%);
    border: 0;
  }
  .van-button--info {
    color: #FFF;
    background-color: #FF0807;
    border: 0;
  }
  .van-button--info.van-button--plain {
    color: #FF0807;
    background-color: transparent;
    border: 1px solid #FF0807;
  }
  .van-button--disabled {
    opacity: 1;
    color: #666;
    background: #EAEAEA;
  }
  .van-cell {
    width: auto;
    color: #999;
  }
}
</style>